/** @format */

const paperDustLogs = {
  // paper 页曝光
  paperPageShowLog: {
    event: 'page_show',
    params: {
      page: 'paper',
    },
  },
  // paper 页发表评论
  paperCommentLog: {
    event: 'comment',
    params: {
      page: 'paper',
    },
  },
  // paper 页点击喜欢star
  paperStarClickLog: {
    event: 'paper_star',
    params: {
      page: 'paper',
    },
  },
  // paper 页点击相关推荐
  paperRelatedRecClickLog: {
    event: 'click',
    params: {
      page: 'paper',
    },
  },
};

export default paperDustLogs;
